import storageManager from "modules/storage-manager";

const getEncryptedAccessToken = () => {
    const userData = storageManager.user.get();
    const token = userData?.encryptedAccessToken;

    return token;
}

export default getEncryptedAccessToken;